import React from 'react';
import { TextField } from "@mui/material";
import { PanelAvailabilityStatusSelect } from "../../components/MaterialSelects/PanelAvailabilityStatusSelect";
import { DistributorSelect } from "../../components/MaterialSelects/DistributorSelect";
import { BoroughSelect } from "../../components/MaterialSelects/BoroughSelect";
import { PanelPackSelect } from "../../components/MaterialSelects/PanelPackSelect";
import { RegionSelectGrouped } from "../../components/MaterialSelects/RegionSelectGrouped";
import { RegionTypeSelect } from "../../components/MaterialSelects/RegionTypeSelect";
import { SiteStructureSelect } from "../../components/MaterialSelects/SiteStructureSelect";
import { SubletterSelect } from "../../components/MaterialSelects/SubletterSelect";
import { IsoDateRangePicker } from "../../components/IsoDateRangePicker";
import { IsoDatePicker } from "../../components/IsoDatePicker";
import { PostcodeAreaSelect } from "../../components/MaterialSelects/PostcodeAreaSelect";
import { SiteTagSelect } from "../../components/MaterialSelects/SiteTagSelect";
import SearchForm from "../../components/search-form";
import { SiteOwnerSelect } from '../../components/MaterialSelects/SiteOwnerSelect';
//import {SiteTagSelect} from "../../components/MaterialSelects/SiteTagSelect";

class DigitalSearch extends React.Component {
    static fieldTypes = [
        {
            label: 'Name', id: 'name',
            default: true,
            variants: [
                {
                    default: true,
                    label: 'Like',
                    id: 'like',
                    editor: ({ input }) => <TextField {...input} autoComplete="site-name" label="Name" />
                },
            ]
        }, {
            label: 'Region', id: 'regionId',
            variants: [{
                id: 'in',
                label: 'Lookup',
                clearOnChange: true,
                multi: true,
                editor: ({ input }) => <RegionSelectGrouped multiple={true} valueIsId={true} {...input} />
            }]
        }, {
            label: 'Site Structure', id: 'structureId',
            variants: [{
                id: 'in',
                label: 'Lookup',
                getValue: (val) => {
                    return val.id;
                },
                multi: true,
                editor: ({input}) =><SiteOwnerSelect multiple={true} {...input} valueIsId={true}/>
            }]
        },
    ];

    render() {
        return <SearchForm onCancel={this.props.onCancel} onSearch={this.props.onSearch} isOpen={this.props.isOpen}
            params={this.props.params}
            fieldTypes={DigitalSearch.fieldTypes}
            name="sites"
            label="Sites "
        />
    }
}

export default DigitalSearch;
